import { Component, OnInit } from '@angular/core';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { ReportePresupuestoService } from 'src/app/services/reporte-presupuesto.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'indicadores',
  templateUrl: './indicadores.component.html',
  styleUrls: ['./indicadores.component.scss']
})
export class IndicadoresComponent implements OnInit {

  public dataFederales: any;
  public dataRurales: any;

  public readonly CARRETERAS_FEDERALES: string = '1';
  public readonly CAMINOS_RURALES: string = '0';

  public lotesPresupuestos: LotePresupuesto[] = [];
  public presupuestosFederales: PresupuestoEstado[] = [];
  public presupuestosRurales: PresupuestoEstado[] = [];

  public obrasFederales: PresupuestoEstado[] = [];
  public derechoViaFederales: PresupuestoEstado[] = [];
  public estudiosProyectosFederales: PresupuestoEstado[] = [];

  public obrasRurales: PresupuestoEstado[] = [];
  public conservacionInfraestructura: PresupuestoEstado[] = [];
  public estudiosProyectosRurales: PresupuestoEstado[] = [];

  public sumaObrasFederales: any;
  public sumaDerechoViaFederales: any;
  public sumaEstudiosProyectosFederales: any;

  public sumaObrasRurales: any;
  public sumaConservacionInfraestructura: any;
  public sumaEstudiosProyectosRurales: any;

  public subTotalFederales: any[] = [];
  public subTotalRurales: any[] = [];

  public readonly ESTUDIOS_Y_PROYECTOS_RURALES: string = "Programa de Estudios y Proyectos de Caminos Rurales y Alimentadores 2020";
  public readonly CONSERVACION_INFRAESTRUCTURA: string = "Programa de Conservación de Infraestructura de Caminos Rurales y Carreteras 2020";
  public readonly DERECHO_DE_VIA: string = "LIBERACIÓN DE DERECHO DE VÍA";
  public readonly ESTUDIOS_Y_PROYECTOS_FEDERALES: string = "ESTUDIOS Y PROYECTOS DE CONSTRUCCIÓN DE CARRETERAS";


  public totalFederalesProgramas: number = 0;
  public totalRuralesProgramas: number = 0;
  public datosCargados: boolean = false;

  public options: any = {
    aspectRatio: 1,
    tooltips: {
      intersect: true,
      callbacks: {
        label: function (tooltipItem, data) {
          let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'MXN',
          });
          return formatter.format(data.datasets[0].data[tooltipItem.index]).substring(2);
        }
      }
    },
    plugins: {
      datalabels: {
        formatter: function (value, context) {
          let formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'MXN',
          });
          return formatter.format(value).substring(2);
        },
        color: 'black',
        font: {
          // weight: 'bold',
          size: 12
        }
      }
    },
  };


  public dataModificadoFederales: any;
  public dataModificadoRurales: any;

  public optionsModificadoProgramasRurales: any;
  public optionsModificadoProgramasFederales: any;

  constructor(private reportePresupuestoService: ReportePresupuestoService) { }

  async ngOnInit() {
    await this.obtenerDatos();
    await this.obtenerSumasFederales();
    await this.obtenerSumasRurales();
    await this.obtenerSubtotales();
    await this.enviarInformacion();
    await this.crearGraficaModificadoProgramas();
    this.datosCargados = true;
  }



  async obtenerDatos() {
    this.lotesPresupuestos = await this.reportePresupuestoService.findByAnioPef('').pipe(
      take(1)
    ).toPromise();
    for (let index = 0; index < this.lotesPresupuestos.length; index++) {
      if (this.lotesPresupuestos[index].keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
        this.presupuestosRurales = this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados;
      } else if (this.lotesPresupuestos[index].keyCatDireccionAdjunta === this.CARRETERAS_FEDERALES) {
        this.presupuestosFederales = this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados;
      }
    }
    this.obrasFederales = this.presupuestosFederales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra !== this.ESTUDIOS_Y_PROYECTOS_FEDERALES && presupuesto.nombreObra !== this.DERECHO_DE_VIA);
    this.derechoViaFederales = this.presupuestosFederales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra === this.DERECHO_DE_VIA);
    this.estudiosProyectosFederales = this.presupuestosFederales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra === this.ESTUDIOS_Y_PROYECTOS_FEDERALES);

    this.obrasRurales = this.presupuestosRurales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra !== this.CONSERVACION_INFRAESTRUCTURA && presupuesto.nombreObra !== this.ESTUDIOS_Y_PROYECTOS_RURALES);
    this.conservacionInfraestructura = this.presupuestosRurales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra === this.CONSERVACION_INFRAESTRUCTURA);
    this.estudiosProyectosRurales = this.presupuestosRurales.filter((presupuesto: PresupuestoEstado) => presupuesto.nombreObra === this.ESTUDIOS_Y_PROYECTOS_RURALES);
  }

  public async obtenerSumasFederales() {
    let obrasFederales: any = {};
    obrasFederales.sumaPEF = this.obrasFederales.reduce((prev, curr) => prev + curr.pef, 0);
    obrasFederales.sumaModificado = this.obrasFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    obrasFederales.sumaCalendario = this.obrasFederales.reduce((prev, curr) => prev + curr.calendario, 0);
    obrasFederales.sumaTotalEjercido = this.obrasFederales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    obrasFederales.saldo = obrasFederales.sumaCalendario - obrasFederales.sumaTotalEjercido;
    this.sumaObrasFederales = obrasFederales;

    let derechoViaFederales: any = {};
    derechoViaFederales.sumaPEF = this.derechoViaFederales.reduce((prev, curr) => prev + curr.pef, 0);
    derechoViaFederales.sumaModificado = this.derechoViaFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    derechoViaFederales.sumaCalendario = this.derechoViaFederales.reduce((prev, curr) => prev + curr.calendario, 0);
    derechoViaFederales.sumaTotalEjercido = this.derechoViaFederales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    derechoViaFederales.saldo = derechoViaFederales.sumaCalendario - derechoViaFederales.sumaTotalEjercido;
    this.sumaDerechoViaFederales = derechoViaFederales;

    let estudiosProyectosFederales: any = {};
    estudiosProyectosFederales.sumaPEF = this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.pef, 0);
    estudiosProyectosFederales.sumaModificado = this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    estudiosProyectosFederales.sumaCalendario = this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.calendario, 0);
    estudiosProyectosFederales.sumaTotalEjercido = this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    estudiosProyectosFederales.saldo = estudiosProyectosFederales.sumaCalendario - estudiosProyectosFederales.sumaTotalEjercido;
    this.sumaEstudiosProyectosFederales = estudiosProyectosFederales;
  }

  public async obtenerSumasRurales() {
    let obrasRurales: any = {};
    obrasRurales.sumaPEF = this.obrasRurales.reduce((prev, curr) => prev + curr.pef, 0);
    obrasRurales.sumaModificado = this.obrasRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    obrasRurales.sumaCalendario = this.obrasRurales.reduce((prev, curr) => prev + curr.calendario, 0);
    obrasRurales.sumaTotalEjercido = this.obrasRurales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    obrasRurales.saldo = obrasRurales.sumaCalendario - obrasRurales.sumaTotalEjercido;
    this.sumaObrasRurales = obrasRurales;

    let conservacionInfraestructura: any = {};
    conservacionInfraestructura.sumaPEF = this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.pef, 0);
    conservacionInfraestructura.sumaModificado = this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    conservacionInfraestructura.sumaCalendario = this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.calendario, 0);
    conservacionInfraestructura.sumaTotalEjercido = this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    conservacionInfraestructura.saldo = conservacionInfraestructura.sumaCalendario - conservacionInfraestructura.sumaTotalEjercido;
    this.sumaConservacionInfraestructura = conservacionInfraestructura;

    let estudiosProyectosRurales: any = {};
    estudiosProyectosRurales.sumaPEF = this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.pef, 0);
    estudiosProyectosRurales.sumaModificado = this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0);
    estudiosProyectosRurales.sumaCalendario = this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.calendario, 0);
    estudiosProyectosRurales.sumaTotalEjercido = this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.totalEjercido, 0);
    estudiosProyectosRurales.saldo = estudiosProyectosRurales.sumaCalendario - estudiosProyectosRurales.sumaTotalEjercido;
    this.sumaEstudiosProyectosRurales = estudiosProyectosRurales;
  }

  public async obtenerSubtotales() {
    let subTotalFederales: any = {};
    subTotalFederales.sumaModificado = this.sumaObrasFederales.sumaModificado + this.sumaDerechoViaFederales.sumaModificado + this.sumaEstudiosProyectosFederales.sumaModificado;
    subTotalFederales.sumaCalendario = this.sumaObrasFederales.sumaCalendario + this.sumaDerechoViaFederales.sumaCalendario + this.sumaEstudiosProyectosFederales.sumaCalendario;
    subTotalFederales.sumaTotalEjercido = this.sumaObrasFederales.sumaTotalEjercido + this.sumaDerechoViaFederales.sumaTotalEjercido + this.sumaEstudiosProyectosFederales.sumaTotalEjercido;
    subTotalFederales.saldo = this.sumaObrasFederales.saldo + this.sumaDerechoViaFederales.saldo + this.sumaEstudiosProyectosFederales.saldo;
    this.subTotalFederales.push(subTotalFederales.sumaModificado, subTotalFederales.sumaCalendario, subTotalFederales.sumaTotalEjercido, subTotalFederales.saldo);

    let subTotalRurales: any = {};
    subTotalRurales.sumaModificado = this.sumaObrasRurales.sumaModificado + this.sumaConservacionInfraestructura.sumaModificado + this.sumaEstudiosProyectosRurales.sumaModificado;
    subTotalRurales.sumaCalendario = this.sumaObrasRurales.sumaCalendario + this.sumaConservacionInfraestructura.sumaCalendario + this.sumaEstudiosProyectosRurales.sumaCalendario;
    subTotalRurales.sumaTotalEjercido = this.sumaObrasRurales.sumaTotalEjercido + this.sumaConservacionInfraestructura.sumaTotalEjercido + this.sumaEstudiosProyectosRurales.sumaTotalEjercido;
    subTotalRurales.saldo = this.sumaObrasRurales.saldo + this.sumaConservacionInfraestructura.saldo + this.sumaEstudiosProyectosRurales.saldo;
    this.subTotalRurales.push(subTotalRurales.sumaModificado, subTotalRurales.sumaCalendario, subTotalRurales.sumaTotalEjercido, subTotalRurales.saldo);
  }

  public async enviarInformacion() {
    this.dataFederales = {
      labels: ['Modificado', 'Calendarizado', 'Ejercido', 'Saldo'],
      datasets: [
        {
          data: this.subTotalFederales,
          backgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b",
            "#e80000"
          ],
          hoverBackgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b",
            "#e80000"
          ]
        }],
      legend: {
        display: false
      },
      aspectRatio: 1
    };

    this.dataRurales = {
      labels: ['Modificado', 'Calendarizado', 'Ejercido', 'Saldo'],
      datasets: [
        {
          data: this.subTotalRurales,
          backgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b",
            "#e80000"
          ],
          hoverBackgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b",
            "#e80000"
          ]
        }],
      legend: {
        display: false
      },
      aspectRatio: 1
    };
  }

  public crearGraficaModificadoProgramas() {
    this.totalFederalesProgramas = this.obrasFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0) +
      this.derechoViaFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0) +
      this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0);

    this.totalRuralesProgramas = this.obrasRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0) +
      this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.modificadoSia, 0) +
      this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0);

    this.dataModificadoFederales = {
      labels: ['Obra', 'Derecho de Vía', 'Estudios y Proyectos'],
      datasets: [
        {
          data: [
            this.obrasFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0),
            this.derechoViaFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0),
            this.estudiosProyectosFederales.reduce((prev, curr) => prev + curr.modificadoSia, 0)
          ],
          backgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b"
          ],
          hoverBackgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b"
          ]
        }],
      legend: {
        display: false
      },
      aspectRatio: 1
    };

    this.dataModificadoRurales = {
      labels: ['Obra', 'Conservación', 'Estudios y Proyectos'],
      datasets: [
        {
          data: [
            this.obrasRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0),
            this.conservacionInfraestructura.reduce((prev, curr) => prev + curr.modificadoSia, 0),
            this.estudiosProyectosRurales.reduce((prev, curr) => prev + curr.modificadoSia, 0)
          ],
          backgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b"
          ],
          hoverBackgroundColor: [
            "#4371c2",
            "#eb7c30",
            "#09b03b"
          ]
        }],
      legend: {
        display: false
      },
      aspectRatio: 1
    };

    this.optionsModificadoProgramasRurales = {
      aspectRatio: 1,
      tooltips: {
        intersect: true,
        callbacks: {
          label: (tooltipItem, data) => {
            let porcentaje: number = 0;
            if (this.totalRuralesProgramas !== 0) {
              porcentaje = data.datasets[0].data[tooltipItem.index] * 100 / this.totalRuralesProgramas;
            }
            let formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'MXN',
            });
            return formatter.format(data.datasets[0].data[tooltipItem.index]).substring(2) + ", " + porcentaje.toFixed(2) + "%";
          }
        }
      },
      plugins: {
        datalabels: {
          formatter: (value, context) => {
            let porcentaje: number = 0;
            if (this.totalRuralesProgramas !== 0) {
              porcentaje = value * 100 / this.totalRuralesProgramas;
            }
            let formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'MXN',
            });
            return formatter.format(value).substring(2) + ", " + porcentaje.toFixed(2) + "%";
          },
          color: 'black',
          font: {
            // weight: 'bold',
            size: 12
          }
        }
      },
    };
    this.optionsModificadoProgramasFederales = {
      aspectRatio: 1,
      tooltips: {
        intersect: true,
        callbacks: {
          label: (tooltipItem, data) => {
            let porcentaje: number = 0;
            if (this.totalFederalesProgramas !== 0) {
              porcentaje = data.datasets[0].data[tooltipItem.index] * 100 / this.totalFederalesProgramas;
            }
            let formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'MXN',
            });
            return formatter.format(data.datasets[0].data[tooltipItem.index]).substring(2) + ", " + porcentaje.toFixed(2) + "%";
          }
        }
      },
      plugins: {
        datalabels: {
          formatter: (value, context) => {
            let porcentaje: number = 0;
            if (this.totalFederalesProgramas !== 0) {
              porcentaje = value * 100 / this.totalFederalesProgramas;
            }
            let formatter = new Intl.NumberFormat('en-US', {
              style: 'currency',
              currency: 'MXN',
            });
            return formatter.format(value).substring(2) + ", " + porcentaje.toFixed(2) + "%";
          },
          color: 'black',
          font: {
            // weight: 'bold',
            size: 12
          }
        }
      },
    };


  }

}
